module.exports = __webpack_public_path__ + "static/img/application_4.621d040.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/application/application_4.jpg
// module id = qXzn
// module chunks = 0